import { withRouter, RouteComponentProps } from 'react-router';
import { AuthPiece } from 'aws-amplify-react/lib/Auth';
import { Location } from 'history';

import { getAuthStateFromPath } from 'helpers';

/**
 * Ensures react-router state is in sync with AWS AuthState
 */
class RouteController extends AuthPiece<RouteComponentProps> {
  constructor(props: RouteComponentProps) {
    super(props);
    this.listener = props.history.listen(this.onRouteChange);
  }

  componentWillUnmount() {
    this.listener && this.listener();
  }

  onRouteChange = (location: Location) => {
    const { pathname } = location;
    const state = getAuthStateFromPath(pathname);

    this.changeState(state);
  };
}

// @ts-ignore - TODO: AWS Components are untyped
export default withRouter(RouteController);
